module.exports = __webpack_public_path__ + "img/logo.249f56f4.png";